<template>
  <div class='footer'>
    <!-- <img :src="globalUrl+ 'static/dist/img/footer.png'"> -->
    <p>中央广播电视总台  央视网  版权所有</p>
  </div>
</template>

<script>
    export default {
        data (){
        return {
          globalUrl : API.GlobalUrl
        }
    },
    methods: {
        //操作按钮事件
    },
    mounted: function () {
        //操作DOM
      var u = navigator.userAgent;
      if (u.indexOf('iPhone') > -1) {//苹果手机
        $('.footer').css('padding-bottom','72px')
      }

    }

    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/template/footer.vue